<!--
 * @FileDescription: 
 * @version: 2.0
 * @Author: 胡明浩
 * @Date: 2021-06-11 16:19:25
 * @LastEditors: 胡明浩
 * @LastEditTime: 2021-09-09 16:41:34
-->
<template>
	<el-dialog
		:title="title"
		:visible.sync="dialogFormVisible"
		class="add-dialog"
		:before-close="close"
		:close-on-click-modal="false"
		:append-to-body="true"
		center
	>
		<el-form
			:model="ruleForm"
			:rules="rules"
			ref="ruleForm"
			label-width="140px"
			class="demo-ruleForm"
		>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item label="企业名称：">
						<el-input maxlength="100" placeholder="请输入企业名称" v-model="companyName" readonly></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<!-- @blur="getBankName" -->
					<el-form-item label="银行账号：" prop="bankAccounts">
						<el-input
							@keyup.native="ruleForm.bankAccounts=ruleForm.bankAccounts.replace(/[^\d-]/g,'')"
							maxlength="50"
							placeholder="请输入银行账号"
							v-model="ruleForm.bankAccounts"
							@blur="getBankName"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item label="开户银行：">
						<el-input maxlength="50" placeholder="请输入开户银行" v-model="ruleForm.bank"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item label="分支行名称：">
						<el-input maxlength="100" placeholder="请输入分支行名称" v-model="ruleForm.branchName"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item label="所在地：">
						<el-col :span="12">
							<el-select
								class="form-item"
								v-model="ruleForm.provinceId"
								placeholder="省/直辖市"
								@change="changeProvince"
							>
								<el-option
									v-for="item in province"
									:key="item.areaId"
									:label="item.areaName"
									:value="item.areaId"
								></el-option>
							</el-select>
						</el-col>
						<el-col :span="11" :offset="1">
							<el-select class="form-item" v-model="ruleForm.cityId" placeholder="市" @change="changeCity">
								<el-option
									v-for="item in city"
									:key="item.areaId"
									:label="item.areaName"
									:value="item.areaId"
								></el-option>
							</el-select>
						</el-col>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item label="账号类型：">
						<el-select class="form-item" v-model="ruleForm.accountType" placeholder="请选择账号类型">
							<el-option
								v-for="item in regionArray"
								:key="item.code"
								:label="item.desc"
								:value="item.code"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="18" :offset="2">
					<el-form-item>
						<el-checkbox label="设为默认收款账号" v-model="ruleForm.isDefault"></el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="foot">
			<el-button class="save" type="primary" @click="submitForm('ruleForm')">保存</el-button>
		</div>
	</el-dialog>
</template>

<script>
// import { bankCardAttribution } from '@/modules/projectA/utils/bank.js'
import Api from '@/modules/projectA/api/nesting/inside'
export default {
	props: {
		dialogFormVisible: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		//反显数据
		details: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			companyName: '', //企业名称
			province: [], //省
			city: [], //市
			regionArray: [
				{
					code: '1',
					desc: '个人账户'
				},
				{
					code: '2',
					desc: '企业账户'
				}
			],
			ruleForm: {
				bankAccounts: '', //银行账号
				bank: '', //开户银行
				branchName: '', //分支行名称
				province: '', //开户的省份
				provinceId: '', //省份编码
				city: '', //分支行城市
				cityId: '', //城市编码
				accountType: '2', //账户类型
				isDefault: false
			},
			rules: {
				bankAccounts: [
					{
						required: true,
						message: '请输入银行账号',
						trigger: 'blur'
					},
					{
						min: 9,
						message: '银行账号输入不正确',
						trigger: 'blur'
					},
					{
						max: 25,
						message: '银行账号输入不正确',
						trigger: 'blur'
					},
				]
			}
		}
	},
	mounted() {
		this.companyName = JSON.parse(
			localStorage.getItem('USERINFO')
		).companyName
		this.queryByParentId()
	},
	methods: {
		close() {
			this.$emit('close')
			this.$refs.ruleForm.resetFields()
			Object.keys(this.ruleForm).forEach(item => {
				if (item != 'accountType') {
					this.ruleForm[item] = ''
				}
			})
			this.isDefault = false
		},
		//改变省
		changeProvince(areaId) {
			let arr = this.province.filter(ele => {
				return ele.areaId == areaId
			})
			this.ruleForm.province = arr[0].areaName
			this.ruleForm.city = ''
			this.ruleForm.cityId = ''
			this.city = []
			this.queryByParentId(areaId)
		},
		//改变市
		changeCity(areaId) {
			let arr = this.city.filter(ele => {
				return ele.areaId == areaId
			})
			this.ruleForm.city = arr[0].areaName
		},
		//获取地区信息
		queryByParentId(value) {
			Api.queryByParentId({ parentAreaId: value ? value : 0 }).then(
				res => {
					if (res.success) {
						if (value) {
							this.city = res.data
						} else {
							this.province = res.data
						}
					}
				}
			)
		},
		getBankName() {
      this.$refs['ruleForm'].validateField('bankAccounts',valid=>{
        console.log()
        if(!valid){
          Api.bankAccounts({
            bankAccounts: this.ruleForm.bankAccounts
          }).then(res => {
            this.ruleForm.bank = res.data
          })
        }
      })
		},
		addAccount() {
			Api.addAccount({
				...this.ruleForm,
				bankAccountId: this.details.bankAccountId
			}).then(res => {
				if (res.success && res.data) {
					this.close()
					this.$parent.payeeAccount()
					this.$message.success('操作成功')
				}
			})
		},
		//保存
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.addAccount()
				} else {
					setTimeout(() => {
						const isError = document.getElementsByClassName(
							'is-error'
						)
						isError[0].querySelector('input').focus()
					}, 100)
					return false
				}
			})
		}
	},
	watch: {
		details(newVal) {
			if (Object.keys(newVal).length > 0) {
				if (newVal.provinceId) {
					this.queryByParentId(newVal.provinceId)
				}
				this.ruleForm.bankAccounts = newVal.bankAccounts //银行账号
				this.ruleForm.bank = newVal.bank //开户银行
				this.ruleForm.branchName = newVal.branchName //分支行名称
				this.ruleForm.province = newVal.province //开户的省份
				this.ruleForm.provinceId = newVal.provinceId //省份编码
				this.ruleForm.city = newVal.city //分支行城市
				this.ruleForm.cityId = newVal.cityId //城市编码
				this.ruleForm.accountType = newVal.accountType //账户类型
				this.ruleForm.isDefault = newVal.isDefault
			}
		}
	}
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/theme.scss';
::v-deep.el-input__inner {
	border-radius: 0;
	font-family: SourceHanSansCN-Regular, SourceHanSansCN;
}
.el-form-item {
	margin-bottom: 20px;
}
.form-item {
	width: 100%;
}
.foot {
	display: flex;
	justify-content: center;
}
::v-deep .el-dialog__headerbtn {
	top: 12px;
}
.el-dialog__headerbtn:hover {
	.el-dialog__close {
		color: $main-col;
	}
}
::v-deep .el-dialog__header {
	background: #ededed;
	.el-dialog__title {
		font-size: 14px;
		font-family: SourceHanSansCN-Bold, SourceHanSansCN;
		font-weight: bold;
		color: $c3;
		line-height: 14px;
	}
}
::v-deep .el-dialog__body {
	padding: 27px 20px 0px 20px;
	.el-checkbox__input .el-checkbox__inner {
		border-color: #dcdfe6;
	}
	.el-checkbox__input.is-checked.is-focus .el-checkbox__inner {
		border-color: $main-col;
	}
	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #dcdfe6;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner {
		background: $main-col;
		border-color: $main-col;
	}
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background: $main-col;
		border-color: $main-col;
		&::before {
			background-color: $c3;
		}
	}
	.el-checkbox__label {
		color: #333333;
	}
	.save {
		font-size: 14px;
		font-family: SourceHanSansCN-Regular, SourceHanSansCN;
		font-weight: 400;
		color: $cf;
		background-color: $main-col;
		border-color: $main-col;
		width: 200px;
		height: 40px;
		border-radius: 0px;
		margin-bottom: 20px;
		&:hover {
			background-color: $main-hover;
			border-color: $main-hover;
		}
	}
}
</style>